import { render, staticRenderFns } from "./filterdProductViewer.vue?vue&type=template&id=cf864b7e&scoped=true&"
import script from "./filterdProductViewer.vue?vue&type=script&lang=js&"
export * from "./filterdProductViewer.vue?vue&type=script&lang=js&"
import style0 from "./filterdProductViewer.vue?vue&type=style&index=0&id=cf864b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf864b7e",
  null
  
)

export default component.exports